import { render, staticRenderFns } from "./FlatButtonWithIcon.vue?vue&type=template&id=2f07edc4&"
import script from "./FlatButtonWithIcon.vue?vue&type=script&lang=ts&"
export * from "./FlatButtonWithIcon.vue?vue&type=script&lang=ts&"
import style0 from "./FlatButtonWithIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FlatButtonWithIcon.vue"
export default component.exports